// Generated by ReScript, PLEASE EDIT WITH CARE


var isInteg = sdkUrl === "https://dev.hyperswitch.io";

var isSandbox = sdkUrl === "https://beta.hyperswitch.io" || sdkUrl === "http://localhost:9050";

var isProd = sdkUrl === "https://checkout.hyperswitch.io";

var targetOrigin = "*";

export {
  targetOrigin ,
  isInteg ,
  isSandbox ,
  isProd ,
}
/* isInteg Not a pure module */
